import type { ReactNode } from 'react'

import styled from 'styled-components'

import ErrorPopup from './errorPopup'

export type ErrorStateProps = {
  title: string
  description: string
  textButton: string
  onTryAgain: () => void
  instruction?: string
  contentLoader?: ReactNode
}

const Backdrop = styled.div`
  width: 100%;
`

const ErrorState = ({
  title,
  description,
  textButton,
  onTryAgain,
  instruction,
  contentLoader
}: ErrorStateProps) => {
  return (
    <div
      className='_d-flex _flex-column _flex-wrap _align-items-center _justify-content-center _position-relative'
      data-test='error-state'>
      <Backdrop>{contentLoader}</Backdrop>

      <ErrorPopup
        title={title}
        textButton={textButton}
        description={description}
        instruction={instruction}
        onTryAgain={onTryAgain}
      />
    </div>
  )
}

export default ErrorState
